// extracted by mini-css-extract-plugin
export default {"home":"Home_home__sAY0w","logo":"Home_logo__A+Aho","title":"Home_title__9Lk-Y","subtitle":"Home_subtitle__rubuv"};